module.exports = {"validation":{"required":"Ez a mező kötelező","email":"Érvénytelen e-mail cím"}}